/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import ApiCaller from "~/api/ApiCaller";
import {
  GetReferrerSitesResponse,
  PostDecodePayload,
  PostDecodeResponse,
  PostEncodePayload,
  PostEncodeResponse,
} from "~/features/oneClick/types";

const OneClickApi = {
  getReferrerSites: () => ApiCaller.get<GetReferrerSitesResponse>("/v1/reseller/referrer"),
  postEncode: (data: PostEncodePayload) => ApiCaller.post<PostEncodeResponse>("/v1/oneclick/encode", data),
  postDecode: (data: PostDecodePayload) => ApiCaller.post<PostDecodeResponse>("/v1/oneclick/decode", data),
};

export default OneClickApi;
